// extracted by mini-css-extract-plugin
module.exports = {"ctaContainer":"styles__ctaContainer___2zpHF","rightAlign":"styles__rightAlign___1ATis"};